// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d14259f7","455":"abd84ad3","977":"60052c5a"}[chunkId] + ".chunk.js";
};